import { useEffect } from "react";

const SITE_URL = "https://dobedosoft.com";
const DEFAULT_TITLE = "Dobedo Soft | AI, Web & Mobile Product Engineering";

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

// Keeps the document title, description, canonical URL and social tags in sync per route.
export default function usePageMeta({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Dobedo Soft` : DEFAULT_TITLE;
    const url = `${SITE_URL}${path}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
  }, [title, description, path]);
}
